module.exports = __webpack_public_path__ + "static/img/Picture3.d027462.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/191017/Picture3.jpg
// module id = 3J5a
// module chunks = 1